/*
 * Copyright (c) Siemens Energy AG 2020 ALL RIGHTS RESERVED
 *
 * I&C Monitors and Advisors (ICMA)
 */

import React from 'react';
import placeHolder from '../../../assets/images/place_holder.png';

const MEDIUM_OPTIMIZATION = 0.3334;
const HIGH_OPTIMIZATION = 0.6667;
const COLOR_OPTIMIZATION_HIGH = '#FF0202';
const COLOR_OPTIMIZATION_MEDIUM = '#FFC20F';
const COLOR_OPTIMIZATION_LOW = '#A1D72E';
const COLOR_OPTIMIZATION_INVALID_ERROR = '#e8e8ec';

export default class AccordionComponent extends React.Component {
  changeRouteTo() {
    let pageToRouteTo =
      this.props.service === 'sha' ? 'sh' : this.props.service;

    if (this.props.service === 'mdr') {
      window.open(this.props.redirect, '_blank');
      return;
    }

    if (this.props.service === 'tr' || this.props.service === 'if') {
      this.props.history.push({
        pathname: '/' + pageToRouteTo
      });
    } else {
      this.props.history.push({
        pathname: '/' + pageToRouteTo + '/monitor'
      });
    }
  }

  maintenanceCalculator() {
    let maintenance = {
      underMaintenance: false,
      MaintenanceReson: 'Maintenance Reson Default text'
    };
    let service = this.props.service === 'sha' ? 'sh' : this.props.service;
    if (
      this.props.isPlantMaint !== undefined &&
      this.props.isPlantMaint.hasOwnProperty(service)
    ) {
      if (this.props.isPlantMaint[service].isUnderMnt) {
        maintenance.underMaintenance = true;
        maintenance.MaintenanceReson =
        this.props.isPlantMaint[service].reason;
      }
    }
    return maintenance;
  }

  colorTextCalculator() {
    let colorRgb;
    let textValue;
    if (this.props.optimization === -1 || this.props.optimization === -2) {
      colorRgb = COLOR_OPTIMIZATION_INVALID_ERROR;
    } else {
      if (this.props.optimization < MEDIUM_OPTIMIZATION) {
        colorRgb = COLOR_OPTIMIZATION_LOW;
        textValue = 'LOW';
      } else {
        if (this.props.optimization < HIGH_OPTIMIZATION) {
          colorRgb = COLOR_OPTIMIZATION_MEDIUM;
          textValue = 'MEDIUM';
        } else {
          colorRgb = COLOR_OPTIMIZATION_HIGH;
          textValue = 'HIGH';
        }
      }
    }
    return { colorRgb, textValue };
  }

  isSiemensAccordian(optimizationHtml, buttonText, maintenance) {
    if (!this.props.serviceIncluded || maintenance.underMaintenance) {
      optimizationHtml = 'Siemens Energy only - ' + optimizationHtml;
      //for servicen not subscribed
      if (!this.props.serviceIncluded) {
        optimizationHtml = optimizationHtml + 'Service not subscribed | ';
      }
      //for plant under Maintenance
      if (maintenance.underMaintenance) {
        optimizationHtml = optimizationHtml + 'Under Maintenance | ';
      }
    }

    let moreButton;

    if (this.props.env !== 'cep') {
      moreButton = (
        <button
          className="dls-button bottom-right application-header-ah4"
          // onClick={() => changeContent(' ', '', '0', this.props.cpid)}
        >
          {buttonText}
        </button>
      );
    } else {
      moreButton = (
        <button
          className="dls-button bottom-right application-header-ah4"
          onClick={() => this.changeRouteTo()}
        >
          {buttonText}
        </button>
      );
    }

    return { optimizationHtml, moreButton };
  }

  isPremiumAccordian(
    optimizationHtml,
    buttonText,
    maintenance,
    moreButton,
    text,
    colorRgb
  ) {
    let contentClass;
    let textBox;
    if (maintenance.underMaintenance) {
      contentClass = 'dls-lp-acc-td-padding limited';
      optimizationHtml = 'Under Maintenance |';
      textBox = (
        <div className="textBox">
          Under Maintenance {maintenance.MaintenanceReson}
        </div>
      );
      if (this.props.isSiemens) {
        optimizationHtml = 'Siemens Energy only | ' + optimizationHtml;
        contentClass = 'dls-lp-acc-td-padding';
        if (this.props.env !== 'cep') {
          moreButton = (
            <button
              className="dls-button bottom-right application-header-ah4"
              // onClick={() => changeContent(' ', '', '0', this.props.cpid)}
            >
              {buttonText}
            </button>
          );
        } else {
          moreButton = (
            <button
              className="dls-button bottom-right application-header-ah4"
              onClick={() => this.changeRouteTo()}
            >
              {buttonText}
            </button>
          );
        }
        textBox = text;
      } else {
        colorRgb = COLOR_OPTIMIZATION_INVALID_ERROR;
      }
    } else {
      contentClass = 'dls-lp-acc-td-padding';
      if (this.props.env !== 'cep') {
        moreButton = (
          <button
            className="dls-button bottom-right application-header-ah4"
            // onClick={() => changeContent(' ', '', '0', this.props.cpid)}
          >
            {buttonText}
          </button>
        );
      } else {
        moreButton = (
          <button
            className="dls-button bottom-right application-header-ah4"
            onClick={() => this.changeRouteTo()}
          >
            {buttonText}
          </button>
        );
      }
      textBox = text;
    }
    return { optimizationHtml, contentClass, moreButton, textBox, colorRgb };
  }

  case2(optimizationHtml, maintenance) {
    if (!maintenance.underMaintenance || this.props.isSiemens) {
      optimizationHtml = <div>{optimizationHtml} No data received.</div>;
    } else {
      optimizationHtml = optimizationHtml.split('|')[0];
      optimizationHtml = <div>{optimizationHtml}</div>;
    }
    return optimizationHtml;
  }
  case3(optimizationHtml) {
    if (this.props.limited === 'isSiemens') {
      optimizationHtml = <div>{optimizationHtml} Service not subscribed.</div>;
    } else {
      optimizationHtml = <div>{optimizationHtml} Service not available.</div>;
    }
    return optimizationHtml;
  }
  defaultcase(optimizationHtml, maintenance) {
    if (maintenance.underMaintenance && !this.props.isSiemens) {
      optimizationHtml = 'Under Maintenance';
    } else {
      optimizationHtml = (
        <div>
          {optimizationHtml} Optimization Need -{' '}
          <span className="portal-medium-text">
            {this.colorTextCalculator().textValue}
          </span>
        </div>
      );
    }
    return optimizationHtml;
  }

  render() {
    let text = this.props.text.map((textDetails, index) => {
      return (
        <div key={this.props.service + '_textline_' + index}>{textDetails}</div>
      );
    });
    let maintenance = this.maintenanceCalculator();
    /*
      create html for optimization state
      optimization value of -1 describes loading state,
      optimization value of -2 describes invalid data or error,
      optimization value between 0 and 1 describes valid data
    */
    let optimizationHtml = '';
    //Creating Text based on the Application
    let buttonText = 'More';
    if (this.props.service === 'tr') {
      buttonText = 'Reports';
      text =
        'Omnivise-reports provide you an opportunity to make reports from Omnivise T3000 available in a secure way. Any manual copy with the risk of infecting your process control system with malware is avoided.Please push "Reports" to access the latest reports that were uploaded.';
    }
    if (this.props.service === 'if') {
      buttonText = 'Go';
      text = 'Internal Functions';
    }
    if (this.props.service === 'mdr') {
      buttonText = 'More';
      text =
        'Managed Detection and Response, powered by Eos. ii, provides analyst-backed continuous monitoring of OT environments. The MDR Dashboards interface provides key service indicators and information regarding active investigations for customer review, and exportable status and compliance reports are refreshed every few hours with recent data for on-demand usage.';
    }

    // color of background will be gray for loading state, invalid data and errors
    let { colorRgb } = this.colorTextCalculator();
    //changes for limited access/content management
    let contentClass, moreButton, textBox;
    //for isSiemens user case
    if (this.props.limited === 'isSiemens') {
      contentClass = 'dls-lp-acc-td-padding';
      textBox = text;
      let resObj = this.isSiemensAccordian(
        optimizationHtml,
        buttonText,
        maintenance
      );
      optimizationHtml = resObj.optimizationHtml;
      moreButton = resObj.moreButton;
    }
    // for End customer plant user
    else {
      // for NON PREMIUM plant user
      if (this.props.limited === 'limited') {
        contentClass = 'dls-lp-acc-td-padding limited';
        textBox = (
          <div className="textBoxLarge">
            <p>
              Service not subscribed - For more information on ICMA services
              please visit{' '}
              <a
                href="https://www.siemens-energy.com/icma"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.siemens-energy.com/icma
              </a>{' '}
              or contact your sales representative.
            </p>
          </div>
        );
        colorRgb = COLOR_OPTIMIZATION_INVALID_ERROR;
      }
      // for PREMIUM plant user
      else {
        let resObj = this.isPremiumAccordian(
          optimizationHtml,
          buttonText,
          maintenance,
          moreButton,
          text,
          colorRgb
        );
        optimizationHtml = resObj.optimizationHtml;
        contentClass = resObj.contentClass;
        moreButton = resObj.moreButton;
        textBox = resObj.textBox;
        colorRgb = resObj.colorRgb;
      }
    }

    switch (this.props.optimization) {
      case -1:
        optimizationHtml = <div>{optimizationHtml} Fetching data...</div>;
        break;
      case -2:
        optimizationHtml = this.case2(optimizationHtml, maintenance);
        break;
      case -3:
        optimizationHtml = this.case3(optimizationHtml);
        if (!this.props.limited === 'isSiemens') {
          colorRgb = COLOR_OPTIMIZATION_INVALID_ERROR;
        }
        break;
      default:
        // um + enduser=''
        // um + siemens user=optimation
        // siemens=optimation
        // subsribe + end user=optimization
        optimizationHtml = this.defaultcase(optimizationHtml, maintenance);
        break;
    }

    if (this.props.service === 'mdr') {
      colorRgb = COLOR_OPTIMIZATION_INVALID_ERROR;
      if (this.props.limited === 'isSiemens') {
        optimizationHtml = (
          <div>Siemens Energy only - Service not subscribed.</div>
        );
      } else {
        optimizationHtml = <div>Service subscribed.</div>;
      }
    }
    if (this.props.service === 'tr' || this.props.service === 'if') {
      optimizationHtml = '';
      colorRgb = COLOR_OPTIMIZATION_INVALID_ERROR;
    }
    return [
      <div key={this.props.service + '_accord'}>
        <div
          className="dls-lp-acc-serv-opt-bar"
          style={{
            background: `linear-gradient(to right, ${COLOR_OPTIMIZATION_INVALID_ERROR}, ${colorRgb})`
          }}
        ></div>
        <div className="accordion">
          <h2 className="application-header-ah3 closed dls-lp-acc-h2">
            {this.props.header}
          </h2>
          <span className="portal-medium-text dls-lp-acc-span">
            {optimizationHtml}
          </span>
          <div
            className="accordion-content"
            style={{ display: 'none' }}
            id={this.props.service}
          >
            <table className="dls-lp-acc">
              <tbody>
                <tr>
                  <td className="dls-lp-acc-td">
                    <img src={placeHolder} alt="" />
                  </td>
                  <td className={contentClass}>
                    <span className="portal-header-text-01 dls-lp-acc-td-span">
                      {textBox}
                      <div className="portal-header-text-01"></div>
                    </span>
                    {moreButton}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    ];
  }
}
